import { useState } from 'react'
import { Row, Media, Table, Nav, NavItem, TabContent, TabPane, NavLink, List } from 'reactstrap'
import classnames from 'classnames'
import { getMaterialHoverLabel } from '../../../shared/materialLabels'

/**
 * For if Unit has Dream Awakening.
 * 
 * Use Tabs. Create based on which section is available
 * Assign each tab number uniquely based on element so can conditional render
 */

const Dream = ({ dream }) => {
    return (
        <div className="gs-unit-dream">
            <Header />
            <Tabs dream={dream} />
        </div>
    )
}

const Header = () => {
    return (
        <Row className="gs-unit-block">
            <h3 className="gs-unit-section-title">DREAM AWAKENING</h3>
            <p className="gs-unit-detail__note">
                This unit has Dream Awakening unlocked.<br/>
                Please select a Tab to view the available passive(s) for each pathway.
            </p>
        </Row>
    )
}

const Tabs = ({ dream }) => {
    const firstTab = dream.fire ? 1
        : dream.water ? 2
        : dream.earth ? 3
        : dream.light ? 4
        : dream.dark ? 5
        : 1

    const [currentTab, setCurrentTab] = useState(firstTab)

    const toggle = tab => {
        if (currentTab !== tab) setCurrentTab(tab)
    }
    
    return (
        <center>
            <Nav pills justified className="gs-tabs gs-tabs--compact">
                {
                    dream.fire && 
                    <TabLinks type="CRIMSON" currentTab={currentTab} toggle={toggle} tabNum={1} />
                }
                {
                    dream.water && 
                    <TabLinks type="AQUEOUS" currentTab={currentTab} toggle={toggle} tabNum={2} />
                }
                {
                    dream.earth && 
                    <TabLinks type="VERDANT" currentTab={currentTab} toggle={toggle} tabNum={3} />
                }
                {
                    dream.light && 
                    <TabLinks type="LUMINOUS" currentTab={currentTab} toggle={toggle} tabNum={4} />
                }
                {
                    dream.dark && 
                    <TabLinks type="SPECTRAL" currentTab={currentTab} toggle={toggle} tabNum={5} />
                }
            </Nav>
            <TabContent activeTab={currentTab}>
                {
                    dream.fire &&
                        <Contents tabId={1} pathway="fire" passive={dream.fire.passive} evolution={dream.fire.evolution} />
                }
                {
                    dream.water &&
                        <Contents tabId={2} pathway="water" passive={dream.water.passive} evolution={dream.water.evolution} />
                }
                {
                    dream.earth &&
                        <Contents tabId={3} pathway="earth" passive={dream.earth.passive} evolution={dream.earth.evolution} />
                }
                {
                    dream.light &&
                        <Contents tabId={4} pathway="light" passive={dream.light.passive} evolution={dream.light.evolution} />
                }
                {
                    dream.dark &&
                        <Contents tabId={5} pathway="dark" passive={dream.dark.passive} evolution={dream.dark.evolution} />
                }
            </TabContent>
        </center>
    )
}

const TabLinks = ({ type, currentTab, toggle, tabNum }) => {
    return (
        <NavItem>
            <NavLink className={classnames({ active: currentTab === tabNum })}
                onClick={() => toggle(tabNum)}>
                    <span style={{userSelect: "none"}}>{type}</span>
            </NavLink>
        </NavItem>
    )
}

const Evolution = ({ evo, pathway }) => {
    const imageSize = {
        maxHeight: 75,
        maxWidth: 75,
        padding: 0
    }

    const slots = [1, 2, 3, 4, 5].filter((index) => evo[`mat${index}`]);

    return (
        <Row className="gs-unit-block">
            <div className="gs-unit-table-scroll gs-unit-table-scroll--mats">
                <Table className="gs-unit-table gs-unit-table--mats">
                    <tbody>
                    <tr>
                        {slots.map((index) => {
                            const label = getMaterialHoverLabel(evo, index);
                            return (
                                <th key={`${pathway}-mat${index}`}>
                                    <center>
                                        <span className="gs-mat-tip" title={label || undefined}>
                                            <Media
                                                src={evo[`mat${index}`]}
                                                alt={label || 'Dream material'}
                                                style={imageSize}
                                                loading="lazy"
                                            />
                                        </span>
                                    </center>
                                </th>
                            );
                        })}
                    </tr>
                    
                    <tr>
                        {slots.map((index) => (
                            <td key={`${pathway}-amt${index}`} style={{ padding: 0 }}>
                                <center>x{evo[`mat${index}amt`]}</center>
                            </td>
                        ))}
                    </tr>
                    </tbody>
                </Table>
            </div>
        </Row>
    )
}

const Contents = ({ tabId, passive, evolution, pathway }) => {
    return (
        <TabPane tabId={tabId}>
            <center>
                <Evolution evo={evolution} pathway={pathway} />
                <Passive passive={passive} />
            </center>
        </TabPane>
    )
}

const Passive = ({ passive }) => {
    return (
        <Row className="gs-unit-block">
            <h3 className="gs-unit-section-title">DREAM PASSIVES</h3>
            <List type="unstyled" className="gs-unit-passive-list">
                <li style={{ marginBottom: "1em" }}>{passive.ability1}</li>
                {passive.ability2 &&
                    <li style={{ marginBottom: "1em" }}>{passive.ability2}</li>}
            </List>
        </Row>
    )
}

export default Dream
